<template>
  <el-popover ref="popover2" placement="bottom-start" trigger="click" :visible-arrow="false" v-model="visiblePopOver" popper-class="poppev-condition-name">
    <div :class="['condition-menu',JSON.stringify(selectedLevel2Tip)!='{}'?'condition-menu-tips':'',isSearch?'condition-menu-search':'']">
      <el-scrollbar ref='clickselect' class="fx-none" wrap-class="clickselect-scroll_wrap level1-scroll-wrap">
        <ul class="level1-menu" :class="{'level-menu-hidde': isSearch}">
          <!--  @mouseenter="level1OptionClick(item)" -->
          <li class="condition-option" :class="{ 'active': item.checked, 'disabled': item.inUse == 2?true:false}" v-for="(item,index) in menuList" :key="index"
            @mouseenter="()=>{item.inUse != 2?level1OptionClick(item):''}">
            <span class="condition-title">{{item.label}}
              <i class="level1-hot" v-if='item.isNew2'></i>
            </span>
          </li>
        </ul>
      </el-scrollbar>
      <el-scrollbar ref='clickselect' class="fx-none" wrap-class="clickselect-scroll_wrap level2-scroll-wrap" :class="{'level2-isSearch-wrap':isSearch}">
        <ul class="level2-menu clearfix" :class="{'level2-only': isSearch,'leve2-height-mini': isSearch && level2Menu.length == 0}">
          <li class="result-title-default" :class="{'result-title': isSearch}">搜索结果：</li>
          <li class="condition-option2" :class="{'active': item.checked,'disabled': item.inUse == 2?true:false}" v-for="(item,index) in level2Menu" :key="index"
            @click="()=>{item.inUse != 2?level2OptionClick(item):''}" @mouseenter="()=>{item.inUse != 2?level2OptionTip(item):''}">
            <div class="conBox">
              <img v-if="item.icon == 1" src="@/assets/new-icon.svg" alt="">
              <span class="condition-title">{{item.keyword}}</span>
              <!-- <el-tooltip class="item" v-if='item.description' effect="light" :content='item.description' placement="bottom-end">
                  <i class="el-icon-info"></i>
                </el-tooltip> -->
            </div>
          </li>
          <li class="no-result-default" :class="{'level2-only': isSearch,'no-result': isSearch && level2Menu.length == 0}">未找到匹配项</li>
        </ul>
      </el-scrollbar>
      <el-scrollbar v-if="JSON.stringify(selectedLevel2Tip)!='{}'" ref='clickselect' class="fx-none" wrap-class="clickselect-scroll_wrap level2-scroll-wrap">
        <div class="level2-menu menu-tips">
          <div class="tips-item">
            <p class="title">维度说明</p>
            <p>{{selectedLevel2Tip['description']}}</p>
          </div>
          <div class="tips-item">
            <p class="title">应用场景</p>
            <p v-html="selectedLevel2Tip['scene']"></p>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div :class="['condition-name', !inputValue && isClickOne?'isEmpty':'']" slot="reference">
      <el-input placeholder="请选择条件" size="small" v-model="inputValue" @focus="focus" @blur="blur" @input="filterName" />
      <div class="err-empty">请选择查询条件</div>
    </div>
  </el-popover>
</template>

<script>
import isNil from 'lodash/isNil'
import cloneDeep from 'lodash/cloneDeep'
// import Clickoutside from '@/utils/clickoutside'
import mixin from './stopon.js'
// import { testUserInfo } from '../../home/api/index.js'
export default {
  mixins: [mixin],
  name: 'conditionName',
  props: ['defaultValue'],
  components: {

  },
  // directives: { Clickoutside },
  inject: ['$_search'],
  data() {
    return {
      isClickOne: false,
      menuList: [],
      inputValue: null,//输入框内容
      level2Menu: [],  //二级节点
      selectedLevel1: {},  //当前选中yi ji
      selectedLevel2: {},  //用于一级节点是否高亮
      isSearch: false,
      visiblePopOver: false,
      selectedLevel2Tip: {},//二级维度说明、应用场景
    }
  },
  watch: {
    '$store.state.advancedSearch.conditionList': {
      immediate: true,
      deep: true,
      handler(e) {
        if (e && e.length) {
          this.menuList = cloneDeep(e)
          // 默认显示
          const { children = [], keyword } = this.menuList[0]
          this.level2Menu = children
          this.menuList[0].checked = true
          this.selectedLevel1.checked = false
          this.selectedLevel1 = this.menuList[0]
        }
      }
    }
  },
  mounted() {
    this.$_search.$on('search', (e) => {
      this.isClickOne = true
      console.log('------點擊搜索啦啦啦啦-----')
    })
  },
  methods: {
    init(inputValue) {
      this.inputValue = inputValue
      this.selectedLevel2.keyword = inputValue
    },
    focus() {


      this.isSearch = false
      this.level2Menu = this.selectedLevel1.conditions
      this.setStyle()
    },
    blur() {
      this.isClickOne = true
      // 当失去焦点时，自动还原为上次选中当选项
      if (this.selectedLevel2.keyword) {
        this.inputValue = this.selectedLevel2.keyword
      }
      this.clearStyle()
    },

    level1OptionClick(params) {
      if (this.selectedLevel1 == params) {
        return false
      }
      const { children = [], keyword } = params
      this.level2Menu = children;
      params.checked = true
      this.selectedLevel1.checked = false;
      this.selectedLevel1 = params;
    },

    level2OptionClick(params) {
      // ??
      this.$emit('getConditionName', params.path || '')
      // 选择不同的赋值??
      if (params !== this.selectedLevel2) {
        this.inputValue = params.keyword;
        this.selectedLevel2.checked = false
        params.checked = true
        this.selectedLevel2 = params
        if (params.parent) {
          params.parent.checked = true
          this.selectedLevel1.checked = false
          this.selectedLevel1 = params.parent
        }
        this.$emit('change', params)
      }
      this.visiblePopOver = false
      this.isSearch = false
      // 与常用推荐相同的项高亮
      this.menuList.forEach(item => {
        item.children.forEach(itemC => {
          if (itemC.keyword == params.keyword) {
            itemC.checked = true
            item.checked = true
          } else {
            itemC.checked = false
          }
        })
      })

    },
    level2OptionTip(params) {
      if (params.description == null || params.scene == null) {
        this.selectedLevel2Tip = {}
      } else {
        let objTip = {
          description: params.description,
          scene: params.scene
        }
        this.selectedLevel2Tip = objTip
      }
    },
    level2OptionMove() {
      this.selectedLevel2Tip = {}
    },

    filterName(value) {
      const arr = []
      const newMenuList = this.menuList.filter(item => item.label !== '推荐')
      newMenuList.forEach(item => {
        item.conditions.forEach(el => {
          if (el.keyword && el.keyword.includes(value)) {
            arr.push(el)
          }
        })
      })
      this.level2Menu = arr;
      if (value && value.length > 0) {
        this.isSearch = true;
      } else {
        this.isSearch = false;
        this.level2Menu = this.selectedLevel1.conditions
      }
      // 对象数组去重
      let result = [];
      let obj = {};
      for (let i = 0; i < this.level2Menu.length; i++) {
        if (!obj[this.level2Menu[i].keyword]) {
          result.push(this.level2Menu[i]);
          obj[this.level2Menu[i].keyword] = true;
        }
      }
      this.level2Menu = result
    },
    closeMenu() {
      // this.menuShow = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.clearfix:after {
  content: "";
  display: block;
  clear: both;
  visibility: hidden;
  height: 0;
}
.condition-name {
  // width: 160px;
  width: 200px;
  position: relative;
  z-index: 2;
}
.condition-menu {
  display: flex;
  width: 446px;
  // width: 430px;
  // background: #fff;
  background: rgba(187, 190, 202, 0.1);
  height: 324px;
  // box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.35);
  z-index: 1000;
  border-radius: 2px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  .level-menu-hidde {
    display: none !important;
  }
  .level1-menu {
    :nth-child(1) {
      // margin-bottom: 11px;
    }
  }
  .level2-menu,
  .level1-menu {
    background: #fff;
    display: inline-block;
    // padding: 12px 8px 24px;
    padding: 12px 0px 24px;
    box-sizing: border-box;
    .no-result-default {
      display: none;
      color: #bfbfbf;
      margin-top: 44px;
      text-align: center;
      font-size: 14px;
    }
    .no-result {
      display: block;
    }
    .result-title-default {
      display: none;
      height: 23px;
      line-height: 23px;
      border-bottom: 1px solid #d9d9d9;
      font-size: 14px;
      color: #bfbfbf;
    }
    .result-title {
      display: block;
    }
    .condition-option2,
    .condition-option {
      // line-height: 24px;
      padding: 0 8px;
      line-height: 36px;
      box-sizing: border-box;
      cursor: pointer;
      display: inline-block;
      &.condition-title {
        font-size: 14px;
        font-weight: 400;
        color: #595959;
      }
      &.active {
        // color: #4f7afd;
        color: #5088ff;
      }
      &.condition-option {
        width: 100%;
        // width: 95%;
      }
      &.condition-option2 {
        // min-width: 50%;
        // float: left;
        // display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &:hover {
          color: #5088ff;
        }
      }
      &:hover {
        // background-color: #ebf0fe;
      }
      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        &:hover {
          color: #262626;
        }
      }
    }
  }
  .condition-hot {
    position: relative;
    top: -4px;
  }
  .level1-menu {
    width: 180px;
    // background: rgba(187,190,202,0.1);
    // padding-left: 8px;
    // padding-right: 8px;
    // box-sizing: border-box;
    .active {
      // background-color: #f7f7f7;
      background: #efefef;
    }
    .condition-option {
      padding-left: 16px;
      box-sizing: border-box;
    }
  }
  .level1-menu {
    :nth-child(2) {
      // border-top: 1px solid #d9d9d9;
    }
  }

  .el-scrollbar:nth-of-type(2) {
    max-width: 266px;
    min-width: 266px;
    .level2-menu {
      max-width: 266px;
      min-width: 266px;
    }
  }
  .condition-title {
    position: relative;
    font-size: 14px;
    .level1-hot {
      position: absolute;
      width: 8px;
      height: 8px;
      background: #ffc613;
      border-radius: 100%;
    }
  }
  .level2-menu {
    width: 100%;
    // width: 90%;
  }
  .level2-only {
    border: none;
  }
  .leve2-height-mini {
    height: 120px;
  }
  .el-icon-info {
    color: #d9d9d9;
  }
  .level2-menu {
    // background: rgba(187,190,202,0.1);
    background: none;
    min-height: 100%;
    // padding: 16px 6px;
    padding: 12px 6px 16px 16px;
    box-sizing: border-box;
    .condition-option2 {
      // padding:6px 6px 0 0;
      padding: 5px 12px 5px 0;
      font-weight: 400;
      // color: #262626;
      color: #5a5e66;
      box-sizing: border-box;
      span {
        font-size: 12px;
      }
    }
  }
  .condition-option2 {
    position: relative;
    .conBox {
      // line-height: 20px;
      // height: 20px;
      height: 24px;
      line-height: 24px;
      background: #f0f2f5;
      border-radius: 3px;
      padding: 0 12px;
      box-sizing: border-box;
      margin-right: 4px;
      img {
        // width: 12px;
        position: absolute;
        right: 4px;
        top: 1px;
      }
    }
  }
  &.condition-menu-tips {
    width: 705px;
    &.noTips {
      .level2-menu.menu-tips {
        background: transparent;
      }
    }
  }
  .level2-menu {
    &.menu-tips {
      background: #fff;
      padding: 20px 14px 20px 8px;
      box-sizing: border-box;
      .tips-item {
        margin-bottom: 24px;
        p {
          font-weight: 400;
          color: #343951;
          line-height: 21px;
          font-size: 13px;
          word-break: break-word;
          // padding-right: 5px;
          // box-sizing: border-box;
        }
        .title {
          padding-left: 8px;
          position: relative;
          box-sizing: border-box;
          font-weight: 500;
          color: #343951;
          line-height: 20px;
          font-size: 14px;
          margin-bottom: 8px;
          &::before {
            content: "";
            width: 2px;
            height: 14px;
            background: #5088ff;
            border-radius: 1px;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            margin: auto;
          }
        }
        &:nth-last-of-type(1) {
          margin-bottom: 0;
        }
      }
    }
    .condition-option2 {
      //  padding: 8px 24px 8px 0;
      box-sizing: border-box;
      display: block;
      float: left;
    }
  }
}
@media screen and (max-width: 1548px) {
  .condition-menu.condition-menu-tips {
    width: 657px;
  }
}
@media screen and (max-width: 1496px) {
  .condition-menu.condition-menu-tips {
    width: 613px;
  }
}
@media screen and (max-width: 1440px) {
  .condition-menu {
    width: 353px;
  }
  .condition-menu.condition-menu-tips {
    width: 536px;
  }
  .condition-menu .level2-menu.menu-tips {
    padding: 20px 20px 20px 10px;
  }
  .condition-menu {
    .el-scrollbar:nth-of-type(2) {
      max-width: 222px;
      min-width: 222px;
      .level2-menu {
        max-width: 222px;
        min-width: 222px;
      }
    }
  }
  .condition-menu .level1-menu {
    width: 130px;
  }
}
@media screen and(max-width:1378px) {
  .condition-menu {
    //  width: 278px;
    width: 300px;
  }
  .condition-menu .level1-menu {
    width: 108px;
    // width: 125px;
  }
  .condition-menu.condition-menu-tips {
    width: 447px;
  }
  .condition-menu .level2-menu {
    padding-left: 10px;
  }

  .condition-menu {
    .el-scrollbar:nth-of-type(2) {
      max-width: 190px;
      min-width: 190px;
      .level2-menu {
        max-width: 190px;
        min-width: 190px;
        //  min-width: 168px;
      }
    }
  }
}
</style>
<style lang="scss" >
.condition-name {
  .el-input__inner {
    // border-radius: 2px 0 0 2px;
    font-size: 12px;
    padding: 0 10px;
    // &:focus {
    //   box-shadow: 0px 0px 8px 0px rgba(255, 144, 82, 0.4);
    //   border: 1px solid;
    //   border-radius: 2px;
    // }
  }
}
.poppev-condition-name {
  margin-top: 4px !important;
  // top: -126px;
}

.condition-menu {
  .el-scrollbar__wrap {
    max-height: 368px;
  }
  .level1-scroll-wrap {
    // overflow-x: visible;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .level2-scroll-wrap {
    // border-left: 1px solid #d9d9d9;
    overflow-x: visible;
    overflow-y: auto;
  }
  .level2-isSearch-wrap {
    .level2-scroll-wrap {
      border-left: none;
      margin-right: 0 !important;
    }
  }
  .el-scrollbar__view {
    height: 100%;
  }
  .el-scrollbar {
    .el-scrollbar__thumb {
      right: 0;
      display: none;
    }
  }
  .el-scrollbar:nth-of-type(3) {
    flex: 1;
    .el-scrollbar__thumb {
      display: block;
    }
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  &.condition-menu-search {
    width: 423px !important;
    .el-scrollbar:nth-of-type(1) {
      width: auto;
    }
    .el-scrollbar:nth-of-type(3) {
      display: none;
    }
    .el-scrollbar:nth-of-type(2) {
      max-width: 100%;
      min-width: 100%;
      .level2-menu {
        max-width: 100%;
        min-width: 100%;
      }
    }
  }
}

.el-popover {
  color: #262626;
  &.poppev-condition-name {
    padding: 0;
  }
  .condition-menu {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.err-empty {
  display: none;
}
.isEmpty {
  position: relative;

  transition: all 0.3s;
  /deep/ input {
    border: 1px solid #f56c6c;
  }
  .err-empty {
    display: block;
    font-size: 12px;
    color: #f56c6c;
    position: absolute;
    z-index: 11;
    bottom: -18px;
    left: 0;
  }
}
</style>